import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIPubby = (namespace: CreateNS) => {
    namespace('pubby')(({ func, prop, deps }) => {
        func('subscribe', deps.subscribePubbyRoom);
        func('unsubscribe', deps.unsubscribePubbyRoom);
        func('getPubbyEventTypes', deps.getPubbyEventTypes);
        func('addPubbyEventListener', deps.addPubbyEventListener);
        func('removePubbyEventListener', deps.removePubbyEventListener);
    });
};
